/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import TermsAndConditionsModal from 'components/organisms/TermsAndConditionsModal';
import { ReconfirmTermsAndConditions } from 'components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { transvoiceLogout } from 'store/authenticate/actions';
import { useNavigate } from 'react-router-dom';

function TermsAndConditionsModalContainer({ onLogout = () => {} }) {
  const [displayProceedModal, setDisplayProceedModal] = useState(false);

  const rejectTermsAndCondition = () => {
    setDisplayProceedModal(!displayProceedModal);
  };

  const navigate = useNavigate();

  const logout = () => {
    navigate('/login');
    onLogout();
  };
  return (
    <div>
      <TermsAndConditionsModal reject={rejectTermsAndCondition} />
      {displayProceedModal && (
        <ReconfirmTermsAndConditions
          cancel={rejectTermsAndCondition}
          accept={logout}
        />
      )}
    </div>
  );
}

TermsAndConditionsModalContainer.propTypes = {
  onLogout: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  onLogout: () => {
    dispatch(transvoiceLogout());
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(TermsAndConditionsModalContainer);
